module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "50px auto"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "240px",
      "height": "auto"
    },
    attrs: {
      "src": "/static/img/logo.png"
    }
  })]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("输入手机号与密码登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35%",
      "margin": "0 auto",
      "padding": "15px"
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "form-default",
    attrs: {
      "model": _vm.vo,
      "label-width": "0px"
    }
  }, [_c('el-col', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "type": "text",
      "id": "inputUsernameEmail",
      "autofocus": true
    },
    model: {
      value: (_vm.vo.name),
      callback: function($$v) {
        _vm.$set(_vm.vo, "name", $$v)
      },
      expression: "vo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.vo.name != null && _vm.vo.name.length > 0) ? _c('el-col', [_c('el-form-item', [(_vm.vo.name != null) ? _c('el-input', {
    attrs: {
      "placeholder": "请输入密码",
      "type": "password",
      "id": "inputPassword"
    },
    model: {
      value: (_vm.vo.password),
      callback: function($$v) {
        _vm.$set(_vm.vo, "password", $$v)
      },
      expression: "vo.password"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.vo.name != null && _vm.vo.name.length > 0 && _vm.vo.password != null && _vm.vo.password.length > 0) ? _c('el-col', [_c('el-form-item', [_c('el-switch', {
    attrs: {
      "active-text": "下次自动登录",
      "active-color": "#13ce66",
      "inactive-color": "#D4D4D4"
    },
    model: {
      value: (_vm.autoLogin),
      callback: function($$v) {
        _vm.autoLogin = $$v
      },
      expression: "autoLogin"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.vo.name != null && _vm.vo.name.length > 0 && _vm.vo.password != null && _vm.vo.password.length > 0) ? _c('el-col', [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "round": "",
      "type": "primary",
      "native-type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                  登录\n                ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.agreeProtocol),
      callback: function($$v) {
        _vm.agreeProtocol = $$v
      },
      expression: "agreeProtocol"
    }
  }, [_vm._v("阅读并同意"), _c('el-link', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("《产品许可与服务协议》"), _c('i', {
    staticClass: "el-icon-view"
  })])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "height": "30px",
      "bottom": "0px",
      "text-align": "center",
      "width": "100%",
      "color": "#222",
      "font-size": "16px"
    }
  }, [_vm._v("\n        Copyright © 2021 广州市东迅电脑科技有限公司. All Rights Reserved.   "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "id": "beian",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备2021161829号")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "产品许可与服务协议",
      "visible": _vm.dialogFormVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "550px",
      "overflow": "auto",
      "padding": "1rem",
      "margin-bottom": "1rem",
      "border": "1px solid #dadde5"
    }
  }, [_c('Protocol')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.agreeProtocol = true;
        _vm.dialogFormVisible = false;
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false;
        _vm.agreeProtocol = false;
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86bd259a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 464
// module chunks = 2